import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ConfBadge, EmptyState, PageHeader } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Audit() {
  const { tenantId } = useAuth();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!tenantId) return;
    api.get(`/tenants/${tenantId}/audit`).then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e)));
  }, [tenantId]);

  const filtered = rows.filter(
    (r) => !q || `${r.action} ${r.entity_type} ${r.actor_email}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <PageHeader
        testid="audit-header"
        eyebrow="Governance"
        title="Audit & activity"
        description="Every configuration change, approval, download and export is recorded and filtered by your clearance."
        actions={
          <Input
            data-testid="audit-filter-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Filter by action, entity or actor"
            className="h-9 w-64 rounded-none text-xs"
          />
        }
      />
      <div className="panel max-h-[calc(100vh-20rem)] divide-y divide-border overflow-y-auto" data-testid="audit-list">
        {filtered.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-3">
            <div className="flex min-w-0 items-center gap-4">
              <span className="w-40 shrink-0 font-mono text-[11px] tabular-nums text-muted-foreground">
                {new Date(r.created_at).toLocaleString()}
              </span>
              <span className="label-caps w-24 shrink-0">{r.action}</span>
              <span className="truncate text-sm">
                {r.entity_type}
                {r.entity_id ? ` · ${r.entity_id.slice(-6)}` : ""}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs text-muted-foreground">{r.actor_email}</span>
              <ConfBadge level={r.confidentiality} />
            </div>
          </div>
        ))}
        {filtered.length === 0 && <EmptyState testid="audit-empty" title="No audit events" message="Nothing recorded at your clearance." />}
      </div>
    </div>
  );
}
